/**
 * The authRoles object defines the authorization roles for the application.
 * Only essential routes are included (20-25 pages)
 */
const commonRoutes = ['/dashboard', '/apps/settings', '/apps/settings/security'];
const authRoles: Record<string, string[]> = {
	Admin: ['/apps/users', '/apps/areas', '/apps/transactions', ...commonRoutes],
	Applicant: [
		'/apps/applications',
		...commonRoutes,
		'/apps/billing',
		'/apps/billing/plans',
		'/apps/billing/payment-method',
		'/apps/billing/subscriptions',
		'/apps/addresses',
		'/apps/documents'
	]
};

/**
 * Get allowed routes for a role, considering plan status for Applicants
 * @param role - User role
 * @param hasPlan - Whether the user has a plan (only matters for Applicants)
 * @returns Array of allowed route paths
 */
export function getAllowedRoutes(role: string, hasPlan = true): string[] {
	const baseRoutes = authRoles[role] || [];

	// For Applicants without a plan, only allow billing/plans route
	if (role === 'Applicant' && !hasPlan) {
		return ['/apps/billing/plans'];
	}

	return baseRoutes;
}

export default authRoles;

